module.exports = __webpack_public_path__ + "img/featuredartist (3).d7dd1a41.jpg";